const hasProxy = (scope) => typeof scope !== 'undefined' && !!scope.Proxy;
export const proxyDefined = hasProxy(
  typeof window !== 'undefined' ? window : {},
);
